<template>
  <div>
    <b-table
      :loading="isLoading"
      :per-page="perPage"
      :striped="true"
      :hoverable="true"
      :selected.sync="selected"
      :bordered="false"
      default-sort="name"
      :data="clients"
      ref="table"
      style="cursor: pointer;"
      :sticky-header="true"
      @click="handleClick"
      class="table-cont"
    >
      <b-table-column v-slot="props" label="Name" field="name">
        {{ props.row.firstName }}
        {{ props.row.lastName === "n/a" ? "" : props.row.lastName }}
      </b-table-column>
      <b-table-column v-slot="props"
        :label="`${contextualGradeLabel()}`"
        field="grade"
        sortable
      >
        {{ props.row.grade }}
      </b-table-column>
      <b-table-column v-slot="props"
        :visible="index !== 0 && index !== 3 && index !== 4 ? true : false"
        :label="`Mastered ${contextualGradeLabel()}`"
        field="matered-grade"
        sortable
      >
        {{ masteredGrade(props.row) }}
      </b-table-column>
      <b-table-column v-slot="props"
        :visible="tableType === 'assessment' && index === 0 ? true : false"
        label="Progress (%)"
        field="assessment-progress"
        sortable
      >
        {{ AssessmentProgress(props.row) }}
      </b-table-column>
      <b-table-column v-slot="props"
        :visible="index === 2 && tableType === 'catchup' ? true : false"
        label="Mastered Concepts"
        field="mastered-concepts"
        centered
        sortable
      >
        {{ conceptsMastered(props.row) }}
      </b-table-column>
      <b-table-column v-slot="props"
        :visible="index === 2 && tableType === 'catchup' ? true : false"
        label="Concepts covered"
        field="concepts-covered"
        centered
        sortable
      >
        {{ conceptsDone(props.row).done }}
      </b-table-column>
      <b-table-column v-slot="props"
        :visible="index === 2 && tableType === 'catchup' ? true : false"
        label="Concepts left to do"
        field="concepts-left"
        centered
        sortable
      >
        {{ conceptsDone(props.row).notDone }}
      </b-table-column>
      <b-table-column v-slot="props"
        :visible="index === 3 && tableType === 'improvements' ? true : false"
        label="Initial Result"
        field="initial-Result"
        centered
        sortable
      >
        {{ initialResult(props.row) }}
      </b-table-column>
      <b-table-column v-slot="props"
        :visible="index === 3 && tableType === 'improvements' ? true : false"
        :label="`Latest Mastered ${contextualGradeLabel()}`"
        field="latest-mastered-grade"
        centered
        sortable
      >
        {{ latestMasteredGrade(props.row) }}
      </b-table-column>
      <b-table-column v-slot="props"
        :visible="index === 3 && tableType === 'improvements' ? true : false"
        label="Reassessments Done"
        field="reassessments-done"
        centered
        sortable
      >
        {{ reassessmentsDone(props.row) }}
      </b-table-column>
      <b-table-column v-slot="props"
        :visible="index === 4 && tableType === 'engagements' ? true : false"
        label="Last active"
        field="last-active"
        centered
        sortable
      >
        {{ lastActive(props.row) }}
      </b-table-column>
      <b-table-column v-slot="props"
        :visible="index === 4 && tableType === 'engagements' ? true : false"
        :label="
          time === 'day'
            ? 'Time spent online today'
            : `Time spent this past ${time}`
        "
        field="engagements"
        centered
        sortable
      >
        {{ timeSpent(props.row) }}
      </b-table-column>
      <b-table-column v-slot="props"
        :visible="
          index === 4 && tableType === 'engagements' && time !== 'day'
            ? true
            : false
        "
        :label="`Days active in past ${time}`"
        field="engagements"
        centered
        sortable
      >
        {{ daysActive(props.row) }}
      </b-table-column>

      <section class="section" slot="empty">
        <div class="has-text-grey has-text-centered">
          <template v-if="isLoading">
            <p>
              <b-icon icon="dots-horizontal" size="is-large" />
            </p>
            <p>Fetching data...</p>
          </template>
          <template v-else>
            <p>
              <b-icon icon="emoticon-sad" size="is-large" />
            </p>
            <p>No learners found.</p>
          </template>
        </div>
      </section>
    </b-table>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";
import localizationMixin from "@/modules/global/mixins/localizationMixin.js";
import moment from "moment";
export default {
  name: "LearnerTable",
  props: {
    index: {
      type: Number,
      required: true
    },
    users: {
      type: Array
    },
    tableType: {
      type: String,
      default: "assessment"
    }
  },
  mixins: [localizationMixin],
  data() {
    return {
      isLoading: false,
      paginated: true,
      perPage: 10,
      selected: null,
      downloadClicked: false
      // threadId: 1
    };
  },
  computed: {
    ...mapState({
      learners: state => state.globalStore.reflectiveData,
      activeUser: state => state.globalStore.activeUser,
      threadId: state => state.globalStore.activeFilterParams.threadId,
      currentSubject: state =>
        state.globalStore.activeFilterParams.currentSubject,
      time: state => state.globalStore.activeFilterParams.time
    }),
    ...mapGetters({
      learners: "globalStore/getFilteredList",
      hasFetchedImprovements: "globalStore/hasFetchedImprovements"
    }),
    clients() {
      let clients = this.users;
      // if tableType is assessment, then sort by assessment progress
      if (this.tableType === "assessment") {
        clients = clients.sort((a, b) => {
          return (
            a.assessmentStates[0].threads[this.threadId].progress -
            b.assessmentStates[0].threads[this.threadId].progress
          );
        });
      }

      return clients;
    },
    timeFrame() {
      if (this.time === "day") {
        return moment().subtract(24, "hours");
      } else if (this.time === "week") {
        return moment().subtract(7, "days");
      } else if (this.time === "month") {
        return moment().subtract(1, "month");
      }
      return moment().subtract(24, "hours");
    }
  },
  mounted() {
    // console.log('users', this.users);
  },
  methods: {
    ...mapMutations({
      isModalActive: "globalStore/updateIsLearnerModalActive",
      updateActiveUser: "globalStore/updateActiveUser"
    }),
    downloadUser(user) {
      this.downloadClicked = true;
      this.$emit("userToDownload", user);
    },
    masteredGrade(user) {
      let grade = user.assessmentStates[0].feedback.find(
        thread => thread.threadId === this.threadId + 1
      );
      return grade ? this.contextualGrade(grade.gradeMastered) : "pending";
    },
    AssessmentProgress(user) {
      return user.assessmentStates[0].threads[this.threadId].progress;
    },
    FindTutorName(userId) {
      let findTutor = this.getCompany._id
        ? this.getCompany.tutorObject.find(tutor => {
            return tutor.learners.includes(userId);
          })
        : null;
      return findTutor ? findTutor.name : "";
    },
    concept(user) {
      return user.catchupStates[0].threads[this.threadId].stage
        ? user.catchupStates[0].threads[this.threadId].stage.concept
        : 1;
    },
    catchupProgress(user) {
      return user.catchupStates[0].threads[this.threadId].stage
        ? (
            user.catchupStates[0].threads[this.threadId].stage.progress * 100
          ).toFixed(2)
        : 0;
    },
    conceptsMastered(user) {
      let threadFeedback = user.assessmentStates[0].feedback.find(
        thread => thread.threadId == this.threadId + 1
      );
      if (threadFeedback) {
        return threadFeedback.conceptMastery.filter(concept => concept == 3)
          .length;
      }
      return "--";
    },
    conceptsDone(user) {
      let unmastered = [];
      let unmasteredConcepts = {
        done: "--",
        notDone: "--"
      };
      let threadFeedback = user.assessmentStates[0].feedback.find(
        thread => thread.threadId == this.threadId + 1
      );
      if (threadFeedback) {
        threadFeedback.conceptMastery.forEach((concept, index) => {
          if (concept !== 3) {
            unmastered.push(index);
          }
        });
        let currentStage = user.catchupStates[0].threads[this.threadId].stage
          ? user.catchupStates[0].threads[this.threadId].stage.concept
          : 0;
        if (currentStage == 0) {
          unmasteredConcepts.done = 0;
          unmasteredConcepts.notDone = unmastered.length;
        } else {
          let conceptPosition = unmastered.findIndex(
            concept => concept == currentStage - 1
          );
          if (conceptPosition == -1) {
            unmasteredConcepts.done = unmastered.length;
            unmasteredConcepts.notDone = 0;
          } else {
            unmasteredConcepts.done = conceptPosition;
            unmasteredConcepts.notDone = unmastered.length - conceptPosition;
          }
        }
      }
      return unmasteredConcepts;
    },
    initialResult(user) {
      if (this.index === 3) {
        return this.contextualGrade(
          user.improvement[this.currentSubject][this.threadId + 1][0]
            .gradeMastered
        );
      }
      return "--";
    },
    latestMasteredGrade(user) {
      if (this.index === 3) {
        let reassessmentArr =
          user.improvement[this.currentSubject][this.threadId + 1].length;
        return this.contextualGrade(
          user.improvement[this.currentSubject][this.threadId + 1][
            reassessmentArr - 1
          ].gradeMastered
        );
      }
      return "--";
    },
    reassessmentsDone(user) {
      if (this.index === 3) {
        return (
          user.improvement[this.currentSubject][this.threadId + 1].length - 1
        );
      }
      return "--";
    },
    lastActive(user) {
      if (user.engagement) {
        if (user.engagement.lastSeen) {
          return moment(user.engagement.lastSeen).fromNow();
        }
        return "--";
      }
      return "--";
    },
    daysActive(user) {
      if (user.engagement) {
        let count = this.countUsersEngagements(user.engagement.dates);
        if (count > 1) return count + " days";
        else return count + " day";
      }
      return "--";
    },
    timeSpent(user) {
      if (user.engagement) {
        let sum = this.sumUsersEngagements(user.engagement.dates);
        if (sum > 1) return sum + " mins";
        else return sum + " min";
      }
      return "--";
    },
    sumUsersEngagements(engagementsArray) {
      let count = 0;
      engagementsArray.forEach(engagement => {
        let s = moment(engagement._id).isSameOrAfter(this.timeFrame);
        if (s) {
          count = count + engagement.t;
        }
      });
      return count;
    },
    countUsersEngagements(engagementsArray) {
      let count = 0;
      engagementsArray.forEach(engagement => {
        let s = moment(engagement._id).isSameOrAfter(this.timeFrame);
        if (s) {
          count++;
        }
      });
      return count;
    },
    handleClick() {
      if (!this.downloadClicked) {
        this.$nextTick(() => {
          if (this.selected) {
            // console.log("SELECTED: ", this.selected);
            this.updateActiveUser(this.selected);
            this.isModalActive(true);
          }
        });
      } else {
        this.downloadClicked = false;
      }
    }
  }
};
</script>
